module.exports = __webpack_public_path__ + "img/RAR.f7c8ac20.png";